import { render } from "./DocumentationLayout.vue?vue&type=template&id=2fda9ae6&scoped=true&ts=true"
import script from "./DocumentationLayout.vue?vue&type=script&lang=ts"
export * from "./DocumentationLayout.vue?vue&type=script&lang=ts"

import "./DocumentationLayout.vue?vue&type=style&index=0&id=2fda9ae6&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fda9ae6"]])

export default __exports__